export const parseQueryString =queryString =>{
    let qstring = {};

    if (queryString != null && queryString !== "") {
        let params = queryString.substring(1).split("&");
        if (params != "") {
            for (var i = 0; i < params.length; i++) {
                let args = params[i].split("=");
                if (args.length === 2) {
                    qstring[args[0]] = args[1].replace("%20", " ");
                }
            }
        }
    }
    return qstring;
};

export const updateQueryStringParam = (key, value) =>{
    
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newParam = key + '=' + value,
        params = '?' + newParam;
    
    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        
        var updateRegex = new RegExp("([\?&])" + key + "[^&]*");
        var removeRegex = new RegExp("([\?&])" + key + "=[^&;]+[&;]?");
        
        if (typeof value == 'undefined' || value == null || value === '') { // Remove param if value is empty
            
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace(/[&;]$/, "");

        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            
            params = urlQueryString.replace(updateRegex, "$1" + newParam);

        } else { // Otherwise, add it to end of query string
            
            params = urlQueryString + "&" + newParam;

        }

    }
    window.history.replaceState({}, "", baseUrl + params);
};
export const initEasyDropDown = (id, onchangeHandler) =>{
    $('#' +id)
                .easyDropDown({
        cutOff: 10,
        wrapperClass: 'dropdown',
        nativeTouch: false,
        onChange: onchangeHandler
    });
    
}
export class TranslationHelper {
    constructor(appTranslations) {
        this.translations = appTranslations;
    }

    getTranslation(key) {
        var translationValue = this.translations[key];
        if (translationValue) {
            return translationValue;
        } else {
            return "Translation with key " + key + " is missing";
        }
    }
}

export class UniqueIdHelper {
    constructor(uniqueSuffix) {
        this.suffix = uniqueSuffix.replace(/[^a-zA-Z0-9\-]/g, "-");
    }

    getId(documentId) {
        return documentId.replace(/[^a-zA-Z0-9\-]/g, "-") + "-" + this.suffix;
    }

    getPropertyId(documentId) {
        return documentId.replace(/[^a-zA-Z0-9\-]/g, "_") + "_" + this.suffix;
    }
}

export const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult
    if (removedIndex === null && addedIndex === null) return arr
  
    const result = [...arr]
    let itemToAdd = payload
  
    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0]
    }
  
    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd)
    }
  
    return result
  }
